import React, { useState } from 'react';
import { RewindRecording } from 'types/recordings';
import { RefState } from 'hooks/useRefState';
import FeedbackModalWrapper from 'components/FeedbackModalWrapper/FeedbackModalWrapper';
import CamFeedbackForm from './CamFeedbackForm';
import CamFeedbackFormSuccess from './CamFeedbackFormSuccess/CamFeedbackFormSuccess';

interface Props {
  cameraId: string;
  cameraName: string;
  currentTimestamp?: RefState<Date | undefined>;
  setIsModalOpen: (isModalOpen: boolean) => void;
  rewindList?: RewindRecording[];
  spotId?: string;
  spotName?: string;
  spotTimezone: string;
  isWavePool?: boolean;
}

const CamFeedbackFormWrapper = ({
  setIsModalOpen,
  cameraId,
  cameraName,
  currentTimestamp,
  rewindList,
  spotId,
  spotName,
  spotTimezone,
  isWavePool,
}: Props) => {
  const [confirmationStep, setConfirmationStep] = useState(false);

  const onFormSubmitCallback = (success: boolean) => {
    if (success) {
      setConfirmationStep(true);
    } else {
      setIsModalOpen(false);
    }
  };

  const handleFeedbackModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <FeedbackModalWrapper
      handleCloseClick={handleFeedbackModalClose}
      title="Cam Feedback"
      subTitle={cameraName}
      showTitle={!confirmationStep}
      dataTestId="cam-feedback-modal"
    >
      {!confirmationStep ? (
        <CamFeedbackForm
          onFormSubmitCallback={onFormSubmitCallback}
          cameraId={cameraId}
          cameraName={cameraName}
          currentTimestamp={currentTimestamp}
          rewindList={rewindList}
          spotId={spotId}
          spotName={spotName}
          spotTimezone={spotTimezone}
          isWavePool={isWavePool}
        />
      ) : (
        <CamFeedbackFormSuccess />
      )}
    </FeedbackModalWrapper>
  );
};

export default CamFeedbackFormWrapper;
